import { useEffect, useState } from 'react';
import ReactModal from 'react-modal';

import { handleResponse } from '../../../../_helpers/handle-response';
import { DropdownDataService } from '../../../../_services/dropdownData.service';
import { formatInputOnBlur } from '../../../../_helpers/utils';
import { validateDecimalInput, validateDecInputTo3Digits } from '../../../../_helpers/validators';
import classes from './CustomerWiseAPISalesPendingModal.module.css';

import Alert from '../../../UI/Alert/Alert';
import Button from '../../../UI/Button/Button';

const CustomerWiseAPISalesPendingModal = props => {

    const [customerId, setCustomerId] = useState('-2');
    const [percentageTypeId, setPercentageTypeId] = useState('-2');
    const [percentageTypeName, setPercentageTypeName] = useState('');
    const [commissionRate, setCommissionRate] = useState();
    const [netCurrency, setNetCurrency] = useState();
    const [customerData, setCustomerData] = useState([]);
    const [percentageTypeData, setPercentageTypeData] = useState([]);
    const [errorMessage, setErrorMessage] = useState(null);
    const [hasError, setHasError] = useState(null);

    useEffect(() => {
        getCustomerList();
        getCommissionType();
        return () => {
            setCustomerId('');
            setPercentageTypeId();
            setCommissionRate();
            setNetCurrency('');
        }
    }, []);

    useEffect(() => {
        setCommissionRate(percentageTypeName === 'ADD ON' ? (0).toFixed(2) : commissionRate);
    }, [percentageTypeName]);

    const customStyles = {
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          width: '35%',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
        }
    };

    const getCustomerList = () => {
        DropdownDataService.getCustomerList('modal').then( result => {
            if(result.data) {
                setCustomerData(result.data.results);
            } else {
                setErrorMessage(result.error.message);
            }
        });
    }

    const getCommissionType = () => {
        DropdownDataService.getCommissionType('modal').then( result => {
            if(result.data) {
                setPercentageTypeData(result.data.results);
            } else {
                setErrorMessage(result.error.message);
            }
        });
    }

    const afterOpenModal = () => {
        setCustomerId(!!props.modalData.customerId ? props.modalData.customerId : '-2');
        setCommissionRate(!!props.modalData.commissionRate ? parseFloat(props.modalData.commissionRate).toFixed(2) : (0).toFixed(2));
        setPercentageTypeId(!!props.modalData.percentageTypeId ? props.modalData.percentageTypeId : '-2');
        setPercentageTypeName(!!props.modalData.percentageTypeName ? props.modalData.percentageTypeName : '');
        setNetCurrency(!!props.modalData.netCurrency ? props.modalData.netCurrency : (0).toFixed(2));
    }
    
    const onModalClose = event => {
        props.onCloseModal('cancel');
    }

    const clearMessages = () => {
        setErrorMessage(null);
        // setHasError(false);
    }
    
    const customerChangeHandler = event => {
        clearMessages();
        setCustomerId(event.target.value);
    }
    
    const commTypeChangeHandler = event => {
        clearMessages();
        const value = event.target.value;
        setPercentageTypeId(value);
        const commTypeName = percentageTypeData.find(data => data.percentageTypeId == value)['percentageTypeName'];
        setPercentageTypeName(commTypeName);
    }
    
    const commissionRateChangeHandler = event => {
        clearMessages();
        const value = event.target.value;
        if(value === '') {
            setCommissionRate(value);
        } else {
            if(validateDecInputTo3Digits(value)) {
                setCommissionRate(value);
            }
        }
    }

    const netCurrencyChangeHandler = event => {
        clearMessages();
        const value = event.target.value;
        if(value === '') {
            setNetCurrency(value);
        } else {
            if(validateDecimalInput(value)) {
                setNetCurrency(value);
            }
        }
    }
    
    const onBlurHandler = (event, digits = 2) => formatInputOnBlur(event.target.value, digits)

    const saveChanges = (reqBody, url, reqMethod) => {
        let apiUrl = 'https://royalinfo.in/api/pavathi/ApiSalesOpening/' + url;
        const requestOptions = {
            method: reqMethod,
            headers: { 
                'Content-Type': 'application/json',
                'Token': localStorage.getItem('accessToken')
            },
            body: JSON.stringify(reqBody)
        };
        fetch(apiUrl, requestOptions)
        .then(handleResponse)
        .then(
            (result) => {
                if(result.data) {
                    props.onCloseModal('save');
                } else if(result.error) {
                    setErrorMessage(result.error.message);
                }
            },
            error => setErrorMessage(error)
        );
    }

    const saveChangesHandler = () => {
        if(props.modalName !== 'Delete' && (customerId === '-2' || percentageTypeId === '-2' || commissionRate === '' || netCurrency <= 0 )) {
            setHasError(true);
        } else {
            setHasError(false);
            let reqBody = {};
            let url = '';
            let reqMethod = '';
            if(props.modalName === 'Add') {
                reqBody = {
                    customerId,
                    percentageTypeId,
                    commissionRate: parseFloat(commissionRate),
                    netCurrency: Number(parseFloat(netCurrency).toFixed(2))
                };
                url = 'AddApiSalesOpening';
                reqMethod = 'POST';
            } else if(props.modalName === 'Edit') {
                reqBody = {
                    customerId,
                    percentageTypeId,
                    commissionRate: parseFloat(commissionRate),
                    netCurrency: Number(parseFloat(netCurrency).toFixed(2))
                };
                url = `UpdateApiSalesOpening?transactionId=${props.modalData.transactionId}`;
                reqMethod = 'PUT';
            } else if(props.modalName === 'Delete') {
                url = `DeleteApiSalesOpening?transactionId=${props.modalData.transactionId}`;
                reqMethod = 'DELETE';
            }
            saveChanges(reqBody, url, reqMethod);
        }
    }

    return (
        <div>
            <ReactModal
                isOpen={props.isModalOpened}
                onAfterOpen={e => afterOpenModal(e)}
                style={customStyles}
                ariaHideApp={false}
                preventScroll={false}
                onRequestClose={props.onCloseModal}
                shouldCloseOnOverlayClick={true}
                shouldCloseOnEsc={true}
                overlayClassName={classes.overlay}
                className='modal-content'
            >
            <div className='modal-header'>
                <h4>{props.modalName} API Sales Pending</h4>
                <Button btnClass='close' onClick={e => onModalClose(e)} btnType='Close' />
            </div>
            <div className='modal-body'>
                <div className='container'>
                    { errorMessage && <Alert alertClassName='danger' message={errorMessage} /> }
                    { (props.modalName === 'Add' || props.modalName === 'Edit') &&
                        <form>
                            <div className={`form-group row has-validation ${classes.inputContainer}`}>
                                <label className='col-sm-4 col-form-label inputLabel'>Customer : </label>
                                <div className='col-sm-8'>
                                    <select className={`form-select ${hasError && customerId === '-2' ? 'is-invalid': ''}`} value={customerId} aria-label=".form-select-sm example" onChange={customerChangeHandler}>
                                        { customerData.map( (value, index) => {
                                            return <option key={`customer-${index}`} value={value.customerId}>{value.customerName}</option>
                                        }) }
                                    </select>
                                    <div className='invalid-feedback'>Please select Customer.</div>
                                </div>
                            </div>
                            <div className={`form-group row has-validation ${classes.inputContainer}`}>
                                <label className='col-sm-4 col-form-label inputLabel'>Commission Type : </label>
                                <div className='col-sm-8'>
                                    <select className={`form-select inputField ${hasError && percentageTypeId === '-2' ? 'is-invalid': ''}`} value={percentageTypeId} aria-label=".form-select-sm example" onChange={commTypeChangeHandler}>
                                        { percentageTypeData.map( (value, index) => {
                                            return <option key={`commType-${index}`} value={value.percentageTypeId}>{value.percentageTypeName}</option>
                                        }) }
                                    </select>
                                    <div className='invalid-feedback'>Please select Commission Type.</div>
                                </div>
                            </div>
                            <div className={`form-group row has-validation ${classes.inputContainer}`}>
                                <label className='col-sm-4 col-form-label inputLabel'>Commission % : </label>
                                <div className='col-sm-8'>
                                    <input type='text' disabled={percentageTypeName === 'ADD ON'} className={`form-control inputField ${hasError && commissionRate === '' ? 'is-invalid': ''}`} style={{textAlign: 'right'}} value={commissionRate} onChange={commissionRateChangeHandler} onBlur={e=>setCommissionRate(onBlurHandler(e, 3))} />
                                    <div className='invalid-feedback'>Please enter Commission %.</div>
                                </div>
                            </div>
                            <div className={`form-group row has-validation ${classes.inputContainer}`}>
                                <label className='col-sm-4 col-form-label inputLabel'>Net Pending : </label>
                                <div className='col-sm-8'>
                                    <input type='text' style={{textAlign:'right'}} className={`form-control inputField ${hasError && netCurrency <= 0 ? 'is-invalid': ''}`} value={netCurrency} onChange={netCurrencyChangeHandler} onBlur={ e => setNetCurrency(onBlurHandler(e))} />
                                    <div className='invalid-feedback'>Please enter Net Pending greater than 0.</div>
                                </div>
                            </div>
                        </form>
                    }
                    { props.modalName === 'Delete' && 
                        <div className={classes.text}>Do you want to Delete API Sales Pending?</div>
                    }
                </div>
            </div>
            <div className='modal-footer' style={{textAlign: 'right'}}>
                <Button btnClass='btn btn-secondary' onClick={e => onModalClose(e)} btnText={props.modalName === 'Delete' ? 'No' : 'Cancel' } btnTitle={props.modalName === 'Delete' ? 'No' : 'Cancel' } />
                <Button btnClass='btn btn-primary' onClick={saveChangesHandler} btnText={props.modalName === 'Delete' ? 'Yes' : 'Save' } btnTitle={props.modalName === 'Delete' ? 'Yes' : 'Save' } />
            </div>
          </ReactModal>
        </div>
    );

}

export default CustomerWiseAPISalesPendingModal;